var userTypeSelectionCtrl = function (restSvc, ifacsSvc, $location, $scope) {

    "use strict";
    this.restSvc = restSvc;
    this.scope = $scope;
    this.location = $location;
    this.isLoaded = false;
    this.language = $scope.$parent.language;
    this.onLoad();

    var ddlDataSource = new kendo.data.DataSource({
        pageSize: 20,
        transport: {
            read: function (options) {
                options.success([{ Name: " ", Id: 0 }, { Name: " ", Id: 1 }]);
            }
        }
    });

    function onChange() {
        var dropdownlist = $("#UserTypeDDL").data("kendoDropDownList");
        var index = dropdownlist.selectedIndex;
        $scope.$parent.userSelectionType = dropdownlist.selectedIndex;
    };

    this.scope.ddlOptions = {
        dataTextField: "Name",
        dataValueField: "Id",
        dataSource: ddlDataSource,
        change: onChange
    };
};

userTypeSelectionCtrl.prototype.getSelection = function () {
    "use strict";

    if (this.isLoaded) {
        var dropdownlist = $("#UserTypeDDL").data("kendoDropDownList");
        var index = dropdownlist.selectedIndex;
        this.scope.userSelectionType = dropdownlist.selectedIndex;

        var linkToGo = '/userSelfRegistration';

        if (this.scope.userSelectionType == 1) {
            linkToGo = '/userInvestorRegistration';
        }
        this.location.url(linkToGo);
    }
};

userTypeSelectionCtrl.prototype.onLoad = function () {
    "use strict";
    var ctrl = this;
    var clientCd = "";
    if (location.hostname.indexOf("-") === -1) {
        clientCd = location.hostname.substr(0, location.hostname.indexOf("."));
    } else {
        clientCd = location.hostname.substr(0, location.hostname.indexOf("-"));
    }
    
    ctrl.clientCd = clientCd;
    var rest = this.restSvc.query({type: "configuration", method: "retrieveClientLoginSetting"}, {"clientCd": clientCd});
    rest.$promise.then(this.passClientLoginSetting(this), this.fail);
};


userTypeSelectionCtrl.prototype.passClientLoginSetting = function (controller) {
    "use strict";
    return function (result) {    	
        controller.userAdminSettingMap = result.userAdminSettingMap;        
        controller.isSelfRegistrationEnabled(controller);
    };
};

userTypeSelectionCtrl.prototype.passUserSelfRegistrationSetting = function (controller) {
    "use strict";
    return function (result) {
        controller.UserSelfRegistrationSetting = result.userSelfRegistrationSettingMap;        
        controller.isLoaded = true;

        // update dropdownlist
        var dataArray = controller.scope.ddlOptions.dataSource.data();
        var length = dataArray.length;

        // iterate and remove items
        var item, i;
        for (i = length - 1; i >= 0; i--) {

            item = dataArray[i];
            controller.scope.ddlOptions.dataSource.remove(item);
        }

        controller.scope.ddlOptions.dataSource.insert({ Name: controller.UserSelfRegistrationSetting.investor, Id: 1});
        controller.scope.ddlOptions.dataSource.insert({ Name: controller.UserSelfRegistrationSetting.advisor, Id: 0});

        var dropdownlist = $("#UserTypeDDL").data("kendoDropDownList");
        dropdownlist.select(controller.scope.userSelectionType);
    }
}

// Only following hosts e.g. {nxg/pmo/nce}, supports user registration.
userTypeSelectionCtrl.prototype.isSelfRegistrationEnabled = function (controller) {
    "use strict";   
    	if ((controller.userAdminSettingMap.userSelfRegistrationLink !== undefined && controller.userAdminSettingMap.userSelfRegistrationLink !== null && controller.userAdminSettingMap.userSelfRegistrationLink.toUpperCase() === "TRUE") 
    			&& (controller.userAdminSettingMap.investorSelfRegisterClient !== undefined && controller.userAdminSettingMap.investorSelfRegisterClient !== null && controller.userAdminSettingMap.investorSelfRegisterClient.toUpperCase() === "TRUE")) {       	
    		this.retrieveUserSelfRegistrationSetting(controller);
        } else {
        	this.onCancel();
        }   
};

userTypeSelectionCtrl.prototype.retrieveUserSelfRegistrationSetting = function (controller) {
    "use strict";
    var rest = controller.restSvc.query({ type: "configuration", method: "retrieveUserSelfRegistrationSetting" }, { "clientCd": controller.clientCd });
    rest.$promise.then(controller.passUserSelfRegistrationSetting(controller), controller.fail);
};

/* Call back the login page upon cancel */
userTypeSelectionCtrl.prototype.onCancel = function () {
    "use strict";
    this.location.url("/login");
};

userTypeSelectionCtrl.$inject = ["restSvc", "ifacsSvc", "$location", "$scope"];

angular.module("iFAST.login")
    .controller("userTypeSelectionCtrl", userTypeSelectionCtrl);



// WEBPACK FOOTER //
// ./WebContent/src/login/userTypeSelection-controller.js